import script from "./_ReviewComments.vue?vue&type=script&setup=true&lang=js"
export * from "./_ReviewComments.vue?vue&type=script&setup=true&lang=js"

import "./_ReviewComments.vue?vue&type=style&index=0&id=793a80b0&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-793a80b0"]])

export default __exports__